import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

// Radix Select can't use '' as an item value; filters use '' for "All", so map it to a sentinel.
const ALL = '__all__';

export type Option = { value: string; label: string };

export function SimpleSelect({ value, onValueChange, options, className, id, placeholder = 'Select…' }: {
  value: string; onValueChange(v: string): void; options: Option[]; className?: string; id?: string; placeholder?: string;
}) {
  return (
    <Select value={value === '' ? ALL : value} onValueChange={(v) => onValueChange(v === ALL ? '' : v)}>
      <SelectTrigger id={id} className={cn('w-full', className)}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={o.value || ALL} value={o.value === '' ? ALL : o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
